import React from 'react'
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const SravastiResidency = () => {
    const carouselSravastiResidency = {
 items: 1,
        loop: true,
        dots: false,
        margin: 0,
        autoplay: true,
        nav: true,
        navText: ['<i class="ti-angle-left" aria-hidden="true"></i>', '<i class="ti-angle-right" aria-hidden="true"></i>'],
        responsiveClass: true,
        responsive: {
            0: {
                dots: false,
            },
            600: {
                dots: false,
            },
            1000: {
                dots: false,
            }
        }
};
    const carouselSravastiResidencythumb = {
  loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: true,
        navText: ["<span class='lnr ti-angle-left'></span>", "<span class='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
};
    return (
        <>
            <header className="headerslider">               
                <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidency}>
                     <div className='item'>
                    <img src='img/slider/Sravasti-slider-1.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                     <div className='item'>
                    <img src='img/slider/Sravasti-slider-2.jpg' loading="lazy" alt="hotel" class="img-fluid" />
                </div>
                    </OwlCarousel>
      
                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </header>

            <section className="room-details1 section-padding" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-title">The Sravasti Residency</div>
                        </div>
                        <div className="col-md-8">
                            <p>A serene haven nestled in the historic city of Sravasti, Uttar Pradesh. Our hotel boasts 56 comfortable rooms, perfect for travelers seeking tranquility and insight into the region's rich Buddhist heritage.</p>
                            <p>Sravasti, a sacred site in Buddhism, was where Gautama Buddha spent 24 rainy seasons, sharing wisdom and teachings. The city is home to the Jetavana monastery, a significant pilgrimage site, and the Anathapindika Stupa. 
                                Stay with us and immerse yourself in the spiritual legacy of this ancient city.</p>
                            <p>At Sravasti Residency, we offer a peaceful retreat, blending modern comforts with a deep connection to the region's cultural and historical significance.
                                 The Hotel is Recognized by Department of Tourism, Government of Uttar Pradesh and 
                                  our property is located right adjacent to Korean monastery. We are also Members of FHRAI and HRAEI.</p>
                            <p></p>
                            <div className="row">
                                <div className="col-md-6">
                                    <h6>Check-in</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-in - 2 PM</p>
                                            </div>
                                        </li>
                                       
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <h6>Check-out</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-out - 12 Noon</p>
                                            </div>
                                        </li>
                                       
                                    </ul>
                                </div>
                               <div className="col-md-12">
                                <div className="cont">
                                    <h3>Address</h3>
                                    <p>Sravasti, Dist. - Sravasti - 271805, U.P. (India)<br />
                                        <strong>Mob. No.</strong> : <a href='tel:+91 9289300358'>+91 9289300358</a><br />
                                        <strong>Tel No.</strong> : <a href='tel:+91 6112 - 255404'>+91 6112 - 255404, 255405</a><br />
                                        <strong>  Email </strong>: <a href='mailto:thesravastiresidency@gmail.com'>thesravastiresidency@gmail.com</a><br />
                                        
                                    </p>
                                </div>
                            </div>

                            </div>
                        </div>
                        <div className="col-md-3 offset-md-1">
                            <h6>Facilities of The Sravasti Residency</h6>
                            <p>The Sravasti Residency provides deluxe air-condition rooms include the following facilities</p>
                            <ul className="mb-30">
                                <li> Multi Cuisine Food</li>
                                <li>24 Hour Hot & Cold Shower</li>
                                <li>Multi-lingual satellite T.V.</li>
                                <li>24 Hour Uninterrupted Power Supply</li>
                                <li>Free High Speed Wi-Fi connectivity</li>
                                <li>Hair Dryer</li>
                                <li>Laundry Services</li>
                                <li>Shopping Arcade</li>
                                <li>Tea / Coffee maker</li>
                                <li>Doctor on call</li>
                                <li>Room service</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rooms5 section-padding bg-white" data-scroll-index="1">
                <div className="container">
                     <div className="section-title">Room Type</div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/s-room-1.jpg" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Single Room</Link></h3>
                                     <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Twin Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/s-room-2.jpg" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Twin/Double Room</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Twin Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/s-room-3.jpg" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Suite</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i className="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div class="col-md-6 col-6">
                                            <ul>
                                                <li><i className="flaticon-bed"></i> Single Bed</li>
                                                <li><i className="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        
                       
                    </div>
                </div>
                <div class="container">
                    <div class="row">
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-2.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-2.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-3.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-3.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-4.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-4.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-5.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-5.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-6.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-6.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-7.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-7.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-8.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-8.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                          <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-10.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-10.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-9.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-9.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-11.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-11.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div class="col-md-3 gallery-item">
                            <div class="img-card">
                                <a href="img/gallery/sravasti-12.jpg" title="" class="img-zoom">
                                    <div class="img-block">
                                        <div class="wrapper-img"> <img src="img/gallery/sravasti-12.jpg" class="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                      
                        
                        
                        
                    </div>
                </div>
            </section>
            
            <section className="section-padding">
                <div className="container">
                     <div className="section-title">Places of Attraction</div>
                     <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidencythumb}>
                    <div className="item thumb">
                        <img src='img/slider/Vibhuti.jpg' alt='' />
                        <p>Vibhuti Nath Temple</p>
                    </div>
                    
                   <div className="item thumb">
                        <img src='img/slider/Suhaildev.jpg' alt='' />
                        <p>Suhaildev Wildlife Sanctuary</p>
                    </div>
                    
                   <div className="item thumb">
                        <img src='img/slider/Kacchi.jpg' alt='' />
                        <p>Kacchi Kuti</p>
                    </div>
                   
                   <div className="item thumb">
                        <img src='img/slider/Ungli.jpg' alt='' />
                        <p>Ungli mar caves</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Patan.jpg' alt='' />
                        <p>Patan devi Shakti peeth</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Vipassana.jpg' alt='' />
                        <p>Vipassana Meditation Centre</p>
                    </div>
                   
                   <div className="item thumb">
                        <img src='img/slider/Digambarjaintemple.jpg' alt='' />
                        <p>Digambar Jain Temple</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Sambhav.jpg' alt='' />
                        <p>Bhagwan Sambhav Nath Birthplace</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Anathpindika.jpg' alt='' />
                        <p>Anathpindika Stupa</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Mongkol.jpg' alt='' />
                        <p>Daen Maha Mongkol Chai</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Anand.jpg' alt='' />
                        <p>Anand bodhi</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Gandhakuti.jpg' alt='' />
                        <p>Gandhakuti</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Jetavana.jpg' alt='' />
                        <p>Jetavana</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/World.jpg' alt='' />
                        <p>World Peace Bell</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Koreatemple.jpg' alt='' />
                        <p>Korea temple</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Koreatemplegallery.jpg' alt='' />
                        <p>Korea temple gallery</p>
                    </div>
                   <div className="item thumb">
                        <img src='img/slider/Orajhar.jpg' alt='' />
                        <p>Orajhar</p>
                    </div>
                  

              </OwlCarousel>
      
                </div>
            </section>

            <section className="bg-white">
                <div className="col-md-12">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3538.9307406852286!2d82.04260337446425!3d27.50252933449712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999daa945fa80d7%3A0xd6dc91ef36d8cb8!2sShravasti%20Residency!5e0!3m2!1sen!2sin!4v1747638129138!5m2!1sen!2sin" width="100%" height="350" frameborder="0" className="mappie" allowfullscreen title="Google Map - The Sravasti Residency"></iframe>

                </div>

            </section>
        </>
    )
};

export default SravastiResidency;